import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
} from '@ionic/angular/standalone';

@Component({
  selector: 'app-information-title',
  templateUrl: './information-title.component.html',
  styleUrls: ['./information-title.component.scss'],
  standalone: true,
  imports: [IonLabel],
})
export class InformationTitleComponent {
  @Input() title?: string;
  @Input() information?: () => void;

  constructor() {}

  callInformation() {
    if (this.information) {
      this.information();
    }
  }
}
